import ImportInstallationsContent from "../modules/installation/pages/ImportInstallations/en";
import ImportCompressorsContent from "../modules/installation/pages/ImportCompressors/en";
import ImportSitesContent from "../modules/company/pages/ImportSites/en";
import ImportClientsContent from "../modules/company/pages/ImportClients/en";
import PrivacyPolicy from "../modules/common/pages/PrivacyPolicy/en";
import CGU from "../modules/common/pages/CGU/en";

export default {
  ImportInstallationsContent,
  ImportCompressorsContent,
  ImportSitesContent,
  ImportClientsContent,
  PrivacyPolicy,
  CGU,
};
